import { render, staticRenderFns } from "./smsRecordForm.vue?vue&type=template&id=31bd33fa&scoped=true"
import script from "./smsRecordForm.vue?vue&type=script&lang=js"
export * from "./smsRecordForm.vue?vue&type=script&lang=js"
import style0 from "./smsRecordForm.vue?vue&type=style&index=0&id=31bd33fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd33fa",
  null
  
)

export default component.exports